var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "layout__subtitle" }, [_vm._v("Виды диаграмм")]),
    _c("div", { staticClass: "uikit-charts" }, [
      _c(
        "div",
        { staticClass: "uikit-charts-item uikit-charts-item-pie-simple" },
        [
          _c("highcharts", {
            staticClass: "uikit-charts-item-chart",
            attrs: { options: _vm.pieChart },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "uikit-charts-item" },
        [
          _c("highcharts", {
            staticClass: "uikit-charts-item-chart",
            attrs: { options: _vm.branchesChart.options },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "uikit-charts-item uikit-charts-item-pie-with-legend" },
        [
          _c("highcharts", {
            staticClass: "uikit-charts-item-chart",
            attrs: { options: _vm.positionsChart.options },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }